function toggleNavBar(){
    const navBar = document.getElementById("nav-bar")
    const contentWrapper = document.getElementById("content-wrapper")

    if(navBar.classList.contains("expanded")){
        navBar.classList.remove("expanded")
        navBar.classList.add("short")

        contentWrapper.style.width = "calc(100% - 56px)"
    }else{
        navBar.classList.remove("short")
        navBar.classList.add("expanded")

        contentWrapper.style.width = "calc(100% - 251px)"
    }
}

export default toggleNavBar